import * as yup from 'yup';

export const DNS_PROVIDERS = {
    ROUTE53: 'route53',
    GODADDY: 'godaddy'
};

export const PROVIDER_OPTIONS = [
    { value: DNS_PROVIDERS.ROUTE53, label: 'AWS Route53' },
    { value: DNS_PROVIDERS.GODADDY, label: 'GoDaddy' }
];

export const AWS_REGIONS = [
    'us-east-1',
    'us-east-2',
    'us-west-1',
    'us-west-2',
    'ca-central-1',
    'eu-west-1',
    'eu-central-1'
];

export const zoneValidationSchema = yup.object({
    baseDomain: yup.string()
        .required('Base domain is required')
        .matches(
            /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
            'Please enter a valid domain name (e.g. example.com)'
        ),
    dnsProvider: yup.string().required('Provider is required'),
    hostedZoneId: yup.string().when('dnsProvider', {
        is: DNS_PROVIDERS.ROUTE53,
        then: yup.string().required('Hosted Zone ID is required for Route53')
    }),
    providerConfig: yup.object({
        access_key_env: yup.string().required('Access Key ENV name is required'),
        secret_key_env: yup.string().required('Secret Key ENV name is required'),
        region: yup.string().when('$provider', {
            is: (p) => p === DNS_PROVIDERS.ROUTE53,
            then: yup.string().required('Region is required for Route53')
        })
    })
});
